import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { isAppError } from '@/shared/api/errors';

type Props = { error: unknown; onRetry?: () => void };

export function ErrorState({ error, onRetry }: Props) {
  const message = isAppError(error) ? error.message : 'Something unexpected happened.';
  const traceId = isAppError(error) ? error.traceId : undefined;
  return (
    <Alert
      severity="error"
      variant="outlined"
      action={onRetry ? <Button color="inherit" size="small" onClick={onRetry}>Try again</Button> : undefined}
    >
      {message}
      {traceId ? ` Reference: ${traceId}` : ''}
    </Alert>
  );
}
